import React, { useEffect, useState } from "react";
import styles from "./badge.module.scss";
import { IBadgeData } from "../../../types/interfaces";
import cx from "classnames";
import CircularText from "./circularText/CircularText";
import Ribon from "./ribon/Ribon";
import GaImage from "../../atoms/Image/Image";
import { useTranslation } from "react-i18next";
import { gaImages } from "../../../assets/globalConstants";

interface BadgeProps extends IBadgeData {}

const Badge: React.FC<BadgeProps> = (props) => {
  const {
    id,
    firstName,
    lastName,
    title,
    extraInfo,
    startDate,
    endDate,
    abbUniName,
    logo,
    icon,
    stampImage,
  } = props;

  const { t } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 672);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 968);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 672);
    setIsDesktop(window.innerWidth >= 968);
  };

  window.addEventListener("resize", handleResize);
  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const circleWords = ` · ${abbUniName} · ${t("badgeComponent.certificate")}`;
  const stampCircleWords = abbUniName?.length
    ? abbUniName?.length > 37
      ? `·${abbUniName}`
      : abbUniName?.length > 10
      ? circleWords
      : circleWords + circleWords
    : ` · ${t("badgeComponent.certificate")} · ${t(
        "badgeComponent.certificate"
      )}`;

  const radius = isMobile ? 70 : isDesktop ? 100 : 73;

  const datesAreOk =
    startDate &&
    startDate !== "Invalid date" &&
    endDate &&
    endDate !== "Invalid date";

  const datesText = datesAreOk
    ? startDate && endDate
      ? `${startDate} - ${endDate}`
      : endDate
    : undefined;

  return (
    <div className={styles.badgeContainer}>
      <div className={styles.badgeContainer__right}>
        <Ribon size={!isDesktop ? "medium" : "large"} />
        <div className={styles.badgeContainer__right__stamp}>
          {stampImage ? (
            <GaImage
              image={{
                src: stampImage,
                alt: "badgeComponent.certificateStampImageAlt",
              }}
              className={styles.badgeContainer__right__stamp__img}
            />
          ) : (
            <div className={styles.badgeContainer__right__stamp__custom}>
              <CircularText
                text={stampCircleWords?.toUpperCase()}
                className={
                  styles.badgeContainer__right__stamp__custom__circleText
                }
                radius={radius}></CircularText>
              <div
                className={
                  styles.badgeContainer__right__stamp__custom__circleWhite
                }></div>
              <div
                className={
                  styles.badgeContainer__right__stamp__custom__circleImg
                }>
                {icon ? (
                  <GaImage
                    image={{
                      src: icon,
                      alt: "badgeComponent.certificateIconAlt",
                    }}
                    className={
                      styles.badgeContainer__right__stamp__custom__circleImg__logo
                    }
                  />
                ) : (
                  <GaImage
                    image={gaImages.startIcon}
                    className={
                      styles.badgeContainer__right__stamp__custom__circleImg__logo
                    }
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.badgeContainer__left}>
        <div className={styles.badgeContainer__left__logoContainer}>
          {logo ? (
            <GaImage
              image={{
                src: logo,
                alt: "badgeComponent.certificateLogoAlt",
              }}
              className={styles.badgeContainer__left__logoContainer__img}
            />
          ) : null}
        </div>
        <div className={styles.badgeContainer__left__data}>
          <div className={styles.badgeContainer__left__data__container}>
            <p
              className={cx(
                "bodyBoldSM neutral600",
                styles.badgeContainer__left__data__container__section
              )}>
              {t("badgeComponent.firstSectionLabel")}
            </p>
            <p
              className={cx(
                "heading5",
                styles.badgeContainer__left__data__container__title
              )}>
              {firstName} {lastName}
            </p>
          </div>

          <div>
            <div className={styles.badgeContainer__left__data__container}>
              <p
                className={cx(
                  "bodyBoldSM neutral600",
                  styles.badgeContainer__left__data__container__section
                )}>
                {t("badgeComponent.secondSectionLabel")}
              </p>
              <p
                className={cx(
                  "heading6",
                  styles.badgeContainer__left__data__container__mediumTitle
                )}>
                {title}
              </p>
              <div
                className={cx(
                  "bodyRegularSM neutral700",
                  styles.badgeContainer__left__data__container__extraInfo
                )}>
                <p className={cx("bodyRegularSM neutral700")}>{extraInfo}</p>
                {datesAreOk && datesText ? (
                  <p className={cx("bodyBoldSM neutral700")}>{datesText}</p>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      <p
        className={cx("bodyBoldCap neutral600", styles.badgeContainer__certId)}>
        {t("badgeComponent.certificateIdLabel")}{" "}
        <span className={cx("bodyRegularCap neutral600")}>{id}</span>
      </p>
    </div>
  );
};

export default Badge;
